import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../images/bg-ourstory.jpg'
import _imports_1 from '../../images/about4.jpg'
import _imports_2 from '../../images/about5.jpg'
import _imports_3 from '../../images/about6.jpg'


const _hoisted_1 = {
  class: "page-container",
  id: "story-container"
}
const _hoisted_2 = {
  id: "story",
  class: "w-full min-h-[calc(100dvh)] h-screen flex flex-col p-10 relative"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"absolute w-full h-full top-0 left-0 z-[-1]\"><img class=\"absolute object-cover w-full h-full\" src=\"" + _imports_0 + "\"><div class=\"absolute w-full h-full bg-gradient-to-r from-[#000000]/60 via-[#080F0F]/60 to-[#0A241A]/60\"></div></div><div class=\"h-12\"></div><div class=\"flex-grow flex flex-col items-center justify-center sm:mb-20\"><div class=\"text-center text-white\"><h1 class=\"font1 text-xl mb-5 uppercase ani-top\">Our Story</h1><p class=\"font2 text-5xl max-w-4xl ani-top\">Moving fast, combining unconventional minds with local expertise and commitment, to create exceptional places and value.</p></div></div>", 3)
const _hoisted_6 = { class: "mx-auto" }
const _hoisted_7 = {
  id: "content",
  class: "w-full p-10 py-20 sm:py-42"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "h-12" }, null, -1)
const _hoisted_9 = { class: "flex flex-col items-center justify-center mb-20 sm:mb-32" }
const _hoisted_10 = { class: "text-center md:flex xl:flex-wrap justify-center max-w-[1420px] relative" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "ani-drawheight-1 w-[1px] bg-black h-full absolute left-1/3 opacity-20 hidden xl:block" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "ani-drawheight-2 w-[1px] bg-black h-full absolute left-2/3 opacity-20 hidden xl:block" }, null, -1)
const _hoisted_13 = { class: "basis-1/1 lg:basis-1/2 xl:basis-1/3 mb-20 py-0 lg:py-20 md:px-20" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", { class: "font1 text-xl mb-5 uppercase ani-top" }, "Investments", -1)
const _hoisted_15 = { class: "ani-top text-lg" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "font2 mb-5" }, "We pair a dynamic capital allocation framework with committed capital, operational agility and empowered teams.", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "font2 mb-5" }, "We invest with creativity and conviction across the risk-reward and opportunity spectrum – single asset, portfolio or platform; public or private; new or existing; debt or equity. We are flexible and nimble.", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "font2 mb-5" }, "The depth and breadth of our team’s experience is complemented with rigorous risk analysis and data-driven decisions. Across sectors and all over The Netherlands and UK market, we have a track record of delivering industry leading risk-adjusted returns.", -1)
const _hoisted_19 = { class: "basis-1/1 lg:basis-1/2 xl:basis-1/3 mb-20 py-0 lg:py-20 md:px-20" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h2", { class: "font1 text-xl mb-5 uppercase ani-top" }, "Developments", -1)
const _hoisted_21 = { class: "ani-top text-lg" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "font2 mb-5" }, "The development team has an established track record of successfully managing real estate development projects. ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "font2 mb-5" }, "From refurbishments to new builds, the property developments we work on encompass a broad variety of building types and usages. Over the last years, our team has created asset value through a combination of creativity, high architecture standards and innovation in synergy with a strong investment and risk management expertise. ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "font2 mb-5" }, "Our knowledge has enabled us to successfully deliver several projects that have created real and sustainable value and generated returns.", -1)
const _hoisted_25 = { class: "basis-1/1 lg:basis-1/2 xl:basis-1/3 py-0 lg:py-20 md:px-20" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h2", { class: "font1 text-xl mb-5 uppercase ani-top" }, "Loans", -1)
const _hoisted_27 = { class: "ani-top text-lg" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "font2 mb-5" }, "Zinc acts as the exclusive asset manager for LOR Finance, a private credit provider, specialized in tailored financing solutions for real estate developers. We originate, structure, and manage secured debt investments across various asset classes and development phases, from land acquisition to construction and repositioning.", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "font2 mb-5" }, "Through deep market insight, active portfolio management, and close partnerships with experienced developers, Zinc ensures disciplined capital deployment and robust risk oversight.", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "font2 mb-5" }, "Our mission is to deliver stable, risk-adjusted returns for LOR Finance, while contributing to the creation of high-quality, future-proof real estate projects.", -1)
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"md:flex max-w-7xl mx-auto\"><div class=\"md:basis-1/3 aspect-[9/12] mb-10 md:mb-0 md:px-5 ani-top\"><img class=\"object-cover w-full h-full\" src=\"" + _imports_1 + "\"></div><div class=\"md:basis-1/3 aspect-[9/12] mb-10 md:mb-0 md:px-5 ani-top\"><img class=\"object-cover w-full h-full\" src=\"" + _imports_2 + "\"></div><div class=\"md:basis-1/3 aspect-[9/12] mb-0 md:mb-0 md:px-5 ani-top\"><img class=\"object-cover w-full h-full\" src=\"" + _imports_3 + "\"></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIconNext = _resolveComponent("SvgIconNext")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_SvgIconNext, { target: "#content" })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _hoisted_17,
              _hoisted_18,
              _createVNode(_component_router_link, {
                to: "/projects/investments",
                class: "font1 uppercase inline-block opacity-60 transition hover:opacity-100"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("View our investments")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _hoisted_23,
              _hoisted_24,
              _createVNode(_component_router_link, {
                to: "/projects/developments",
                class: "font1 uppercase inline-block opacity-60 transition hover:opacity-100"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("View our developments")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _hoisted_29,
              _hoisted_30,
              _createVNode(_component_router_link, {
                to: "/projects/loans",
                class: "font1 uppercase inline-block opacity-60 transition hover:opacity-100"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("View our loans")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _hoisted_31
    ])
  ]))
}